import { useToast } from "context/toast-context/ToastProvider";
import React, { useState } from "react";
import { Form, Button, Container, Alert, Card } from "react-bootstrap";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { login } from "ServerAPI/serverAPI";

const CustomLogin = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [message, setMessage] = useState(null);
  const [cookies, setCookies] = useCookies();
  const [loginLoading, setLoginLoading] = useState(false);
  const navigate = useNavigate();
  const { showToast } = useToast();
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCustomLogin = async (e) => {
    e.preventDefault();
    setLoginLoading(true);
    const payload = {
      loginType: "custom",
      email: formData.email,
      password: formData.password,
    };
    try {
      const response = await login(payload);

      const { data } = response;
      setCookies("email", data.email, {
        secure: true,
        sameSite: "strict",
      });
      setCookies("roleId", data.role.roleId, {
        secure: true,
        sameSite: "strict",
      });
      setCookies("roleName", data.role.roleName, {
        secure: true,
        sameSite: "strict",
      });
      setCookies("name", data.name, { secure: true, sameSite: "strict" });
      setCookies("organizationId", data.organizationId, {
        secure: true,
        sameSite: "strict",
      });
      setCookies("phoneNumber", data.phoneNumber, {
        secure: true,
        sameSite: "strict",
      });
      setCookies("department", data.department, {
        secure: true,
        sameSite: "strict",
      });
      setCookies("domain", data.domain, {
        secure: true,
        sameSite: "strict",
      });
      setCookies("userId", data.userId, {
        secure: true,
        sameSite: "strict",
      });
      setCookies("features", JSON.stringify(data.features), {
        secure: true,
        sameSite: "strict",
      });

      setCookies("userManagement", data.userManagement, {
        secure: true,
        sameSite: "strict",
      });
      navigate("/dashboard/overview");
    } catch (error) {
      showToast(error?.response?.data?.message, "error");
    }
    setLoginLoading(false);
  };
  return (
    <Container>
      <div className="text-center mb-4">
        <img
          src="/sambhuti_learning_logo.png"
          alt="Sambhuti Learning Logo"
          style={{ maxWidth: "100px", height: "auto" }}
        />
      </div>
      <Card className="shadow-lg">
        <Card.Header
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: " #23479F",
          }}
        >
          Login
        </Card.Header>

        <Card.Body>
          <Form onSubmit={handleCustomLogin}>
            <Form.Group className="mb-3" controlId="loginEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="text"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="loginPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100"
              disabled={loginLoading}
            >
              Login
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CustomLogin;
